import { METERS_TYPES } from "./metersTypes";
import { toArray, toObject } from "helpers/convertToObject";

const {
  LOAD_METERS,
  SET_METERS,
  NEW_METER,
  SET_NEW_METER,
  EDIT_METER,
  SET_EDITED_METER,
  DELETE_METER,
  CLEAR_METERS,
  HANDLE_METERS_INPUTS,
} = METERS_TYPES;

const initialState = {
  meters: [],
  metersMap: {},
  //edit
  isAddMode: false,
  isDeleteMode: false,
  editMeter: null,
  station: null,

  meterStatuses: [],

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  },

  stationsByToken: []
};

export const metersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_METERS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_METERS:
      return {
        ...state
      };

    case SET_METERS:
      return {
        ...state,
        meters: payload.meters,
        metersMap: payload.metersMap,
        meterStatuses: payload.meterStatuses
      };

    case EDIT_METER:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editMeter: payload && state.metersMap[payload]
      };

    case NEW_METER:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_METER: {
      const newData = toArray(state.metersMap);
      const newMeters = [payload, ...newData];
      const newMetersMap = toObject(newMeters);

      return {
        ...state,
        meters: newMeters,
        metersMap: newMetersMap
      };
    }

    case SET_EDITED_METER: {
      const newMetersMap = {
        ...state.metersMap,
        [payload.id]: { ...state.metersMap[payload.id], ...payload }
      };
      const newData = toArray(newMetersMap);

      return {
        ...state,
        metersMap: newMetersMap,
        meters: newData
      };
    }

    case DELETE_METER:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_METERS:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
